import { render, staticRenderFns } from "./messageNotice.vue?vue&type=template&id=4b062152&scoped=true&"
import script from "./messageNotice.vue?vue&type=script&lang=js&"
export * from "./messageNotice.vue?vue&type=script&lang=js&"
import style0 from "./messageNotice.vue?vue&type=style&index=0&id=4b062152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b062152",
  null
  
)

export default component.exports